import { pgEnum } from 'drizzle-orm/pg-core';

export const order_status = pgEnum('order_status', [
  'PENDING',
  'IN_PROGRESS',
  'SERVICED',
  'INCOMPLETE',
  'CANCELED',
  'BILLED',
  'PAUSED',
]);
